import { StudioAuditTimelineAction } from "../enums";
import { endpointsMetadata } from "../infrastructure/routes/endpointsMetadata";
import { IHistoryConfig } from "../components/history/models/historyModels";

export const STUDIO_HISTORY_CUTOFF_DATE = new Date("2026-04-10");

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function generateStudioAuditText(
  action: number,
  payload: Record<string, any> | null | undefined,
  actorDisplayName: string | null | undefined,
  _timezone?: string,
): string {
  const actor = escapeHtml(actorDisplayName ?? "Системата");

  switch (action as StudioAuditTimelineAction) {
    case StudioAuditTimelineAction.StudioCreated:
      return `${actor} създаде обекта`;

    case StudioAuditTimelineAction.StudioEdited:
      return `${actor} редактира обекта`;

    case StudioAuditTimelineAction.StudioDeleted:
      return `${actor} изтри обекта`;

    case StudioAuditTimelineAction.StudioRestored:
      return `${actor} възстанови обекта`;

    case StudioAuditTimelineAction.StripeConnected:
      return `${actor} свърза обекта със Stripe`;

    case StudioAuditTimelineAction.StripeDisconnected:
      return `${actor} прекъсна връзката на обекта със Stripe`;

    case StudioAuditTimelineAction.GoogleMeetConnected: {
      const googleEmail =
        typeof payload?.googleEmail === "string" ? payload.googleEmail.trim() : "";
      return googleEmail
        ? `${actor} свърза Google акаунт (${escapeHtml(googleEmail)})`
        : `${actor} свърза Google акаунт`;
    }

    case StudioAuditTimelineAction.GoogleMeetDisconnected:
      return `${actor} прекъсна връзката с Google акаунта`;

    case StudioAuditTimelineAction.GlobalAdminAccessed: {
      const opened = `${actor} отвори обекта като глобален администратор`;
      const reason = typeof payload?.reason === "string" ? payload.reason.trim() : "";
      return reason ? `${opened} – „${escapeHtml(reason)}“` : opened;
    }

    case StudioAuditTimelineAction.GlobalAdminLeft:
      return `${actor} излезе от обекта`;

    case StudioAuditTimelineAction.GlobalAdminOpenedProfile: {
      const profile = typeof payload?.profile === "string" ? payload.profile.trim() : "";
      const opened = profile
        ? `${actor} влезе в профила на ${escapeHtml(profile)} от админ панела`
        : `${actor} влезе в профил на потребител от админ панела`;
      const reason = typeof payload?.reason === "string" ? payload.reason.trim() : "";
      return reason ? `${opened} – „${escapeHtml(reason)}“` : opened;
    }

    default:
      return "Неизвестно действие";
  }
}

export type StudioAuditCategory = "studio";

export function getStudioAuditActionCategory(
  _action: number,
): StudioAuditCategory {
  return "studio";
}

export const STUDIO_AUDIT_CATEGORY_COLORS: Record<StudioAuditCategory, string> =
  {
    studio: "#6366f1",
  };

const dot = (color: string) =>
  `<span style="display:inline-block;width:9px;height:9px;border-radius:50%;background:${color};margin-right:8px;vertical-align:middle;flex-shrink:0"></span>`;

export const STUDIO_AUDIT_COLOR_LEGEND_HTML = `
<div style="line-height:2;min-width:180px">
  <div>${dot("#6366f1")}Обект</div>
</div>`.trim();

export const STUDIO_HISTORY_CONFIG: IHistoryConfig = {
  historyEndpoint: endpointsMetadata.studioAuditLog.getStudioHistory,
  historyQueryParam: "studioId",
  detailEndpoint: endpointsMetadata.studioAuditLog.getDetail,
  cutoffDate: STUDIO_HISTORY_CUTOFF_DATE,
  cutoffDateLabel: "10.04.2026 г.",
  tooltipHtml: STUDIO_AUDIT_COLOR_LEGEND_HTML,
  generateText: generateStudioAuditText,
  getCategory: getStudioAuditActionCategory,
  categoryColors: STUDIO_AUDIT_CATEGORY_COLORS,
};
